import React from 'react';

import { useNavigation } from '../../hooks/useNavigation';
import { RouteTransitionAnimation } from '../../hooks/useNavigation';
import { trackClick } from '../../tracking/Tracking';
import styles from './Link.module.scss';

import { PalmettoLink, PalmettoLinkProps } from '@palmetto/dsm-components';
import classNames from 'classnames';

export interface LinkProps extends Omit<PalmettoLinkProps, 'onClick'> {
  trackingId: string;
  onClick?: () => void;
  variant?: 'standalone' | 'standalone-gray';
  ariaLabel?: string;
  routeTransitionAnimation?: RouteTransitionAnimation;
}

export const Link: React.FC<LinkProps> = (props: LinkProps) => {
  const { href, trackingId, className, children, onClick, target, size, ariaLabel, variant, routeTransitionAnimation } =
    props;
  const { openURL } = useNavigation();
  return (
    <PalmettoLink
      className={classNames(className, {
        [styles.standaloneGray]: variant === 'standalone-gray',
        'cursor-pointer': !!onClick && !href,
      })}
      href={href}
      target={target}
      onClick={(e) => {
        trackClick(trackingId, 'link', {
          href,
          page: window.location.href,
        });
        if (onClick) {
          onClick();
        }
        if (href) {
          if (href.indexOf('tel:') === 0 || href.indexOf('mailto:') === 0) {
            return;
          }
          e.preventDefault();
          openURL(href, routeTransitionAnimation);
        }
      }}
      aria-label={ariaLabel}
      size={size}
    >
      {children}
    </PalmettoLink>
  );
};
